import { createAction } from 'redux-actions';

export const failedDependentRequest = createAction('FAILED_DEPENDENT_REQUEST');
